import React, { useEffect, useRef } from "react";
import classes from "./UpdatesModal.module.css";
import updatesModalVisual from "../../public/HomePage/modalImage.webp";

const UpdatesModal = ({ open, onClose, onDiscover }) => {
  const originalOverflowRef = useRef("");

  useEffect(() => {
    if (!open) {
      document.body.style.overflow = originalOverflowRef.current || "";
      return;
    }

    originalOverflowRef.current = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflowRef.current || "";
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div className={classes.overlay} role="dialog" aria-modal="true" aria-label="Updates">
      <div className={classes.modal}>
        <button className={classes.closeButton} onClick={onClose} aria-label="Schließen">
          &#10005;
        </button>

        <div className={classes.contentPanel}>
          <div className={classes.contentPanelText}>
            <div className={`${classes.badge} semiboldXxs`}>UPDATE</div>
            <h2 className="titleSemibold2">Entdecke unsere Updates &#127881;</h2>
            <p className={`${classes.subtitle} regularLarge`}>
              Der Launch steht kurz bevor!
              <br />
              Mit diesen Updates machst du dein Studio komplett.
            </p>

            <div className={classes.defaultContent}>
              <h3 className={`${classes.sectionTitle} semiboldLarge`}>Mehr Möglichkeiten für dein Studio</h3>
              <ul className={classes.list}>
                <li className="regularSmall">Kostenpflichtiges Equipment hinzufügen</li>
                <li className="regularLarge">Mehr Preisoptionen festlegen</li>
                <li className="regularLarge">Hausregeln individuell einstellen</li>
                <li className="regularLarge">Stornierungsbedingungen anpassen</li>
              </ul>
            </div>

            <div className={classes.mobile450Content}>
                <h3 className={`${classes.sectionTitle} semiboldLarge`}>Mehr Möglichkeiten für dein Studio</h3>
                <ul className={classes.list}>
                  <li className="regularSmall">Kostenpflichtiges Equipment hinzufügen</li>
                  <li className="regularLarge">Mehr Preisoptionen festlegen</li>
                  <li className="regularLarge">Hausregeln individuell einstellen</li>
                  <li className="regularLarge">Stornierungsbedingungen anpassen</li>
                </ul>
            </div>
          </div>

          <div className={classes.contentPanelButtons}>
            <button className={`${classes.primaryButton} mediumLarge`} onClick={onDiscover}>
              Updates entdecken
            </button>
            <button className={`${classes.secondaryButton} mediumLarge`} onClick={onClose}>
              Nicht jetzt
            </button>
          </div>
        </div>

        <div className={classes.visualPanel}>
          <div className={`${classes.visualPanelBadge} semiboldXxs`}>UPDATE</div>
          <img alt="Updates Modal Visual" src={updatesModalVisual} />
        </div>
      </div>
    </div>
  );
};

export default UpdatesModal;
